import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/content';
type Props = {
  /** Element the floating bar should appear after. */
  triggerRef: React.RefObject<HTMLElement>;
};
export function FloatingCTA({
  triggerRef
}: Props) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const target = triggerRef.current;
    if (!target) return;
    const onScroll = () => {
      const rect = target.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    onScroll();
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [triggerRef]);
  return <AnimatePresence data-id="element-35" data-mp="38c9z2do5bd77">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2" data-id="element-36" data-mp="33kifin3eq7qk">
          <div className="mx-auto w-full max-w-2xl rounded-2xl bg-navy-900/95 p-2 shadow-2xl backdrop-blur" data-id="element-37" data-mp="2pc5zo7pd88fo">
            <a href={CHECKOUT_URL} className="flex animate-shake items-center justify-center gap-2 rounded-xl bg-sky-500 px-4 py-3.5 text-center font-display text-sm font-extrabold uppercase tracking-wide text-white transition-colors duration-200 ease-out hover:bg-sky-600 sm:text-base" data-id="element-38" data-mp="2uaz8vnxmdda1">
              Get the system — only $27
            </a>
            <p className="pt-2 text-center text-[11px] font-medium text-navy-200" data-id="element-39" data-mp="2bcdawhxeg2ac">
              One-time payment · Lifetime access · 7-day guarantee
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}